const parseJSON = (json) => {
    try {
        // Try to parse the input as a JSON string
        return JSON.parse(json);
    } catch (error) {
        // If parsing fails, return the input object as is
        return json;
    }
};

const isEmpty = (value) => {
    return (
        value == null ||
        (typeof value === 'string' && value.trim().length === 0)
    );
};

const isEmptyObj = (obj) => {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }
    return true;
};

const formatTime = (timeString) => {
    const [hourString, minute] = timeString.split(':');
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ':' + minute + (hour < 12 ? 'AM' : 'PM');
};

const getUtmSourceBRPURL = (brpSourceUrl) => {
    const str = brpSourceUrl;
    const splitted = str.substring(21);
    let utmSourceStr = splitted.split('&');
    let utmSource = utmSourceStr[0];
    return utmSource;
};

export { parseJSON, isEmpty, isEmptyObj, formatTime, getUtmSourceBRPURL };

export const UPDATE_RM_AMOUNT = (value: any) => {
    let latestRmvalue: string;
    if (!value || value.trim() === '') {
        latestRmvalue = ''; // Remove RM prefix if the input is empty
    } else {
        latestRmvalue = `RM ${value.replace(/\D/g, '')}`; // Add RM prefix
    }
    return latestRmvalue;
};

export const CHANGE_LANGUAGE = (
    language: string,
    url: string,
    translator: any,
) => {
    if (language) {
        let lang = language.toUpperCase();
        localStorage.setItem('language', language);
        localStorage.setItem('switched_language', language);
        let current_url = url;
        if (current_url.includes('language')) {
            let splitUrl = current_url.split('?');
            let newURL = splitUrl[0] + '?language=' + language;
            window.open(newURL, '_self');
            setTimeout(() => {
                translator.use(language);
            }, 1000);
        } else {
            translator.use(language);
        }
    }
};

export function scrollToFirstInvalidControl(formContainer: HTMLElement): void {
    setTimeout(() => {
        const firstInvalidControl = formContainer.querySelector(
            'input.ng-invalid, select.ng-invalid, textarea.ng-invalid, .errorBorderCss #dropdown, .mandatory-doc, .dropdown-error, .checkbox-invalid',
        );
        if (firstInvalidControl) {
            firstInvalidControl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
            const focusableElement = firstInvalidControl as
                | HTMLInputElement
                | HTMLSelectElement
                | HTMLTextAreaElement;
            if (focusableElement && focusableElement.type !== 'checkbox') {
                focusableElement.focus();
                focusableElement.click();
            } else if (
                focusableElement &&
                focusableElement.type === 'checkbox'
            ) {
                focusableElement.focus();
            }
        }
    });
}

export const formatUrlEncode = (str: string): string =>
    str
        .toLowerCase() // ::convrts to lowercase
        .trim() // ::remove spaces
        .replace(/[^a-z0-9\s-]/g, '') // ::remove special chars
        .replace(/\s+/g, '-') // ::replace spaces with -
        .replace(/--+/g, '-') // ::replace multiple hyphens with single hyphen
        .replace(/^-+/, '') // ::trim hyphens from start of text
        .replace(/-+/g, '-'); // ::remove multiple hyphens

export const htmlToString = (html: string): string => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
};

export const normalizeOrderedListContinuation = (rawHtml: string): string => {
    if (!rawHtml) {
        return '';
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = rawHtml;

    let previousOrderedTotal = 0;

    Array.from(wrapper.childNodes).forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }

        const element = node as HTMLElement;

        if (element.tagName !== 'OL') {
            return;
        }

        const previousElement =
            element.previousElementSibling as HTMLElement | null;
        const listItems = element.querySelectorAll(':scope > li').length;

        if (
            previousOrderedTotal > 0 &&
            previousElement?.tagName === 'UL' &&
            !element.hasAttribute('start')
        ) {
            element.setAttribute('start', String(previousOrderedTotal + 1));
        }

        previousOrderedTotal += listItems;
    });

    return wrapper.innerHTML;
};
